export default "__VITE_ASSET__CyZdXpPR__"